import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Navigation } from "@/components/navigation";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Home } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      
      <main className="min-h-screen flex items-center justify-center">
        <div className="container mx-auto px-6">
          <div className="max-w-content mx-auto text-center">
            <div className="glass-panel p-12">
              <div className="text-6xl font-bold text-primary mb-6">404</div>
              <h1 className="font-display font-semibold text-foreground mb-4" style={{ fontSize: '32px', lineHeight: '1.2' }}>
                Page not found
              </h1>
              <p className="text-muted-foreground mb-8 max-w-paragraph mx-auto">
                Sorry, the page you're looking for doesn't exist or has been moved.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Link to="/">
                  <Button variant="default" size="lg" className="group bg-primary hover:bg-primary/90 text-primary-foreground tap-target">
                    <Home className="w-4 h-4 mr-2" />
                    Go home
                  </Button>
                </Link>
                <Button 
                  variant="ghost" 
                  size="lg" 
                  onClick={() => window.history.back()}
                  className="text-muted-foreground hover:text-foreground tap-target"
                >
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Go back
                </Button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NotFound;
